import React, { useEffect } from 'react'
import { createUseStyles } from 'react-jss'
import { Helmet } from 'react-helmet-async'
import theme from '../style/theme'
import { useSelector } from 'react-redux'
import { getPageMetaData, getPageHeadTitle } from '../redux/slices/content'
import Page from './Page'
import Cursor from './Cursor'
import MenuDialog from './MenuDialog'
import CartDrawer from './Cart/CartDrawer'
import cn from 'classnames'

function App () {
  const classes = useStyles()
  const meta = useSelector(getPageMetaData)
  const headTitle = useSelector(getPageHeadTitle)
  const [isLoading, setIsLoading] = React.useState(true)
  // Handle loading state when route changes
  React.useEffect(() => {
    setIsLoading(true)
    const timer = setTimeout(() => {
      setIsLoading(false)
    }, 300)

    return () => clearTimeout(timer)
  }, [])

  // Klaviyo integration
  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=SqM297'
    script.type = 'text/javascript'
    document.body.appendChild(script)
  }, [])

  useEffect(() => {
    const isFormSubmitted = window.localStorage.getItem('klaviyoFormSubmitted')
    if (isFormSubmitted === null) {
      setTimeout(() => {
        window._klOnsite = window._klOnsite || []
        window._klOnsite.push(['openForm', 'XGPMhs'])
        let attempts = 0
        const checkAndAttachButton = setInterval(() => {
          const submitButton = document.querySelector('button.go952291206')
          if (submitButton) {
            submitButton.addEventListener('click', () => {
              window.localStorage.setItem('klaviyoFormSubmitted', 'true')
            })
            clearInterval(checkAndAttachButton)
          } else {
            attempts++
          }
          if (attempts > 10) {
            clearInterval(checkAndAttachButton)
          }
        }, 1000)
      }, 5000)
    }
  }, [])

  return (
    <>
      <Helmet>
        <title>{headTitle}</title>
        {meta && (
          <>
            <meta name='title' content={meta.metaTitle} />
            {meta.metaDescription && <meta name='description' content={meta.metaDescription} />}
            {meta.metaKeywords && <meta name='keywords' content={meta.metaKeywords} />}
            {meta.ogUrl && <meta property='og:url' content={meta.ogUrl} />}
            <meta property='og:site_name' content={meta.siteName} />
            <meta property='og:title' content={meta.metaTitle} />
            {meta.metaDescription && <meta property='og:description' content={meta.metaDescription} />}
            {meta.metaImage && [
              <meta property='og:image' content={meta.metaImage.url} key={0} />,
              <meta property='og:image:width' content={meta.metaImage.width} key={1} />,
              <meta property='og:image:height' content={meta.metaImage.height} key={2} />
            ]}
            {meta.metaImage && <meta name='twitter:card' content={meta.twitterCardType} />}
            {meta.siteName && <meta name='twitter:site' content={meta.siteName} />}
            <meta name='twitter:title' content={meta.metaTitle} />
            {meta.metaDescription && <meta name='twitter:description' content={meta.metaDescription} />}
            {meta.metaImage && <meta name='twitter:image' content={meta.metaImage.url} />}
            <link rel='canonical' href={meta.canonicalUrl} />
          </>
        )}
      </Helmet>
      <div className={cn(classes.pageContainer, { [classes.loading]: isLoading })}>
        <Page />
      </div>
      <Cursor />
      <MenuDialog />
      <CartDrawer />
    </>
  )
}

const useStyles = createUseStyles({
  '@global': {
    ...theme.global,
    '#root': {
      backgroundColor: theme.colors.backgroundColors.default
    },
    '.CartDialog-panel': {
      display: 'none'
    }
  },
  pageContainer: {
    opacity: 1,
    transition: 'opacity 0.3s ease-in-out',
    minHeight: '100vh'
  },
  loading: {
    opacity: 0
  }
}, { name: 'App' })

export default App
